module.exports = __webpack_public_path__ + "img/background-parent-profile.5d53b7e9.png";